import React from "react";
//import { List } from "react-bootstrap/lib/media";

function CustomTab({ tabs, activeTabKey, setTab }) {
  return (
    <div className="hseMenuLinks card">
      {tabs.map((tab) => (
        <a
          key={tab.key}
          className={`pointer ${activeTabKey === tab.key ? "active" : ""}`}
          href
          onClick={() => setTab(tab.key)}
        >
          {tab.label}
        </a>
      ))}
    </div>
  );
}

export default CustomTab;
